import styled from 'styled-components';
import { propStyles } from '../styleHelper';

const Select = styled.select`
  -moz-appearance: none;
  -webkit-appearance: none;
  &::-ms-expand {
    display: none;
  }
  ${propStyles}
`;

export default Select;
